// extracted by mini-css-extract-plugin
export default {"html":"App_html__A2yNO","change_background":"App_change_background__IeJzh","container":"App_container__4L7Vo"};